import { clsx } from 'clsx'

import { ObserveMeOnceIAmMounted } from 'Components/ObserveMeOnceIAmMounted/ObserveMeOnceIAmMounted'

import { ContentCard } from '../ContentCard/ContentCard'
import { Entity } from './Entity'
import type { EntityListCardProps } from './EntityListCard.types'

export const EntityListCard = (props: EntityListCardProps) => {
  const {
    entities,
    title,
    rightContent,
    titleSuffix,
    testId,
    isLazyLoadingCard,
    lazyLoadingProps,
    bodyClassName,
  } = props

  return (
    <ContentCard
      rightContent={rightContent}
      title={title}
      titleSuffix={titleSuffix}
    >
      <ul
        className={clsx('EntityCardList p-0', bodyClassName)}
        data-testid={testId}
      >
        {entities.map(entity => (
          <Entity key={entity.id} {...entity} />
        ))}
      </ul>
      {isLazyLoadingCard &&
        lazyLoadingProps &&
        lazyLoadingProps.hasNextPage &&
        !lazyLoadingProps.isLoading && (
          <ObserveMeOnceIAmMounted
            intersectionObserver={lazyLoadingProps.intersectionObserver}
          />
        )}
    </ContentCard>
  )
}
